import React from 'react';
import styles from './ShippingAddress.module.scss';

function NewsletterOptIn(props: {
  isOptIn: boolean,
  handleOnSelect: any
}) {
  const {
    isOptIn, handleOnSelect,
  } = props;
  return (
    <>
      <div>
        <p className={styles.newsletterTitle}>
          Sign Up for Email to Receive Updates and Product Offers
        </p>
        <div>
          <label htmlFor="newsletter" className={styles.newsletter}>
            <p className={styles.newsletterText}>
              Yes, I want to join FabFitFun newsletter to receive updates, product offers,
              product announcements, and much more! I can opt-out at any time.
            </p>
            <span
              role="checkbox"
              tabIndex={0}
              aria-label="Join FabFitFun newsletter"
              aria-checked={isOptIn}
              className={`${styles.checkbox} ${isOptIn ? styles.isOptIn : ''}`}
              onClick={() => handleOnSelect()}
              onKeyPress={() => handleOnSelect()}
              data-testid="noi-checkbox"
            >
              <i className="far fa-check" />
            </span>
            <input name="newsletter" type="checkbox" hidden />
          </label>
        </div>
      </div>
      <div className={styles.divider} />
    </>
  );
}

export default NewsletterOptIn;
